<template>
  <div class="settings">
    <p style="font-size: 32px">Settings</p>

    <p style="font-size: 16px">Please enter list of Proxies</p>
    <p style="font-size: 12px; color: gray">for example: 1.1.1.1:login:password</p>
    <input
      v-model="selectedProxies"
      type="textarea"
      placeholder="1.1.1.1:login:password"
      :autosize="{
        minRows: 3,
      }"
    />
    <button type="primary" dashed @click="addProxy()" style="margin-top: 20px">Add proxies</button>
    <div class="transactionsList">
      <n-collapse :trigger-areas="triggerAreas">
        <n-collapse-item title="Proxies" name="1">
          <template #header-extra>
            <n-button type="primary" @click="isAddProxy = true">Add Proxy</n-button>
          </template>
          <n-scrollbar>
            <div class="proxyList">
              <n-table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Address</th>
                    <th>Login</th>
                    <th>Password</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(proxy, id) in proxies" :key="proxy">
                    <td>{{ id + 1 }}</td>
                    <td>{{ proxy.ip + ":" + proxy.port }}</td>
                    <td>{{ proxy.login }}</td>
                    <td>{{ proxy.password }}</td>
                    <td>{{ new Date(proxy.createdAt).toLocaleString("ru-RU").replace(",", "") }}</td>
                    <td>{{ proxy.isValid == true ? "OK" : "Error" }}</td>
                    <td>
                      <button tertiary type="error" @click="deleteProxy(proxy.id)">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </n-table>
            </div>
          </n-scrollbar>
        </n-collapse-item>
      </n-collapse>
    </div>
  </div>
</template>

<script>
  import axios from "axios"
  import { computed } from "vue"
  import { useToast } from "vue-toastification"

  export default {
    name: "SettingsComponent",
    data() {
      return {
        proxies: null,
        isAddProxy: false,
        selectedProxies: [],
      }
    },
    methods: {
      loadProxies() {
        axios
          .get(`${process.env.VUE_APP_SERVERHOST}/api/proxy`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })
          .then((res) => {
            this.proxies = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      },
      addProxy() {
        console.log(this.selectedProxies.split("\n"))
        axios
          .post(
            `${process.env.VUE_APP_SERVERHOST}/api/proxy/import`,
            {
              proxies: this.selectedProxies.split("\n"),
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
              },
            }
          )
          .then((res) => {
            console.log(res)
            let result = res.data
            for (let i of result) {
              console.log(i)
              if (i.status == "valid") {
                this.toast.success(`Proxy ${i.proxy.ip}:${i.proxy.port} added successfully!`, { timeout: 2000 })
              } else {
                this.toast.error(`Proxy ${i.proxy} is invalid!`, { timeout: 2000 })
              }
            }
            this.loadProxies()
          })
          .catch((err) => {
            console.log(err)
          })
      },
      deleteProxy(id) {
        axios
          .delete(`${process.env.VUE_APP_SERVERHOST}/api/proxy/${id}`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
            },
          })
          .then((res) => {
            console.log(res)
            this.toast.success("Proxy deleted successfully!", { timeout: 2000 })
            this.loadProxies()
          })
          .catch((err) => {
            console.log(err)
          })
      },
    },
    mounted() {
      this.loadProxies()
    },
    setup() {
      const triggerAreasRef = computed(() => {
        const areas = []
        areas.push("main")
        areas.push("arrow")
        return areas
      })
      const toast = useToast()
      return { triggerAreas: triggerAreasRef, toast }
    },
  }
</script>

<style scoped>
  .settings {
    min-width: 40% !important;
    width: fit-content !important;
    max-width: 80% !important;
    margin: 0 auto;
    max-height: 80vh;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    padding: 2%;
    background-color: #191919;
    border-radius: 14px;
    text-align: left;
    filter: drop-shadow(0 0 6px #191919);
  }
  .transactionsList {
    max-height: 60vh;
  }
  .proxyList {
    max-height: 40vh;
  }
</style>
